// GlobalStyles.js
// App-wide CSS that used to be copy-pasted across App.css, FilterComponent.css,
// AssetDetailsModal.css, ContactsContent.css and Settings.css. Defined once here,
// sourced from design tokens, and rendered at the app root (see index.js).
//
// The app uses a family of `.scrollbarN` utility classes (applied via className)
// that all shared the same thumb styling and only differed in width. They are
// consolidated below. `.scrollbar1` is intentionally an "invisible" scrollbar.

import React from "react";
import GlobalStyles from "@mui/material/GlobalStyles";
import { colors, radii } from "./tokens";

// Standard themed scrollbar of a given width.
const scrollbar = (width) => ({
  "&::-webkit-scrollbar": { width },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    background: colors.scrollbarThumb,
    borderRadius: radii.lg,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: colors.scrollbarThumb,
    boxShadow: "inset 0 0 5px grey",
  },
});

const styles = {
  ".MuiPaper-root": scrollbar("3px"),
  ".scrollbar2": scrollbar("7px"),
  ".scrollbar3": scrollbar("3px"),
  ".scrollbar4": scrollbar("7px"),
  ".scrollbar6": scrollbar("5px"),
  ".modal-content": scrollbar("5px"),
  ".dialogContent": scrollbar("5px"),

  // Invisible scrollbar (transparent thumb, faint grey on hover).
  ".scrollbar1": {
    "&::-webkit-scrollbar": { width: "3px" },
    "&::-webkit-scrollbar-track": { background: "transparent" },
    "&::-webkit-scrollbar-thumb": { background: "transparent" },
    "&::-webkit-scrollbar-thumb:hover": { background: "#555" },
  },
};

const AppGlobalStyles = () => <GlobalStyles styles={styles} />;

export default AppGlobalStyles;
